import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://quintebca.ca";
export const DEFAULT_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_pool-league-portal/artifacts/vcvohfiv_Quinte%20BCA%20Logo.png";

// Central client-side SEO/meta manager. Google renders JS so these are indexed.
// path should be the clean canonical path (no query params), e.g. "/divisions/sunday-trios".
export function Seo({
  title,
  description,
  path = "",
  image,
  type = "website",
  noindex = false,
  jsonLd,
}) {
  const canonical = SITE_URL + (path || "");
  const ogImage = image || DEFAULT_OG_IMAGE;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet prioritizeSeoTags>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Quinte BCA Pool League" />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />

      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(block)}</script>
      ))}
    </Helmet>
  );
}
